exports.routes = {
    home: `/`,
    about: `/about-us`,
    privacy: `/privacy-policy`,
    term: `/terms-and-conditions`,
    subscription: `/subscription-agreement`,
    contact: `/contact-us`,
    login: `/sign-in`,
    signup: `/sign-up`,
    blog: `/blog`,
    blogDetail1: `/blog/info/y​o​u​r-​e​s​s​e​n​t​i​a​l-​g​u​i​d​e-​t​o-​p​i​c​k​i​n​g-​p​r​o​f​e​s​s​i​o​n​a​l-​c​a​r​e-​s​e​r​v​i​c​e​s-​f​o​r-​s​e​n​i​o​r​s`,
    blogDetail2: `/blog/info/t​r​a​n​s​f​o​r​m​i​n​g-​h​o​m​e​c​a​r​e-​t​h​e-​e​s​s​e​n​t​i​a​l-​r​o​l​e-​o​f-​p​r​o​f​e​s​s​i​o​n​a​l-​c​a​r​e​g​i​v​e​r​s`,
    blogDetail3: `/blog/info/h​o​w-​t​o-​f​i​n​d-​s​e​n​i​o​r-​h​o​m​e-​c​a​r​e-​j​o​b​s-​&-​t​h​r​i​v​e-​i​n-​p​r​o​f​e​s​s​i​o​n​a​l-​c​a​r​e`,
    userRegister: `/user/sign-up`,
    otp: `/user/verification-otp`,
    dashboard: `/user/dashboard`,
    userDetail: `/user/info`,
    advertisementDetails: `/user/advertisement/info`,
    findCare: `/user/find-care`,
    findCareHomeAss: `/user/find-care-home-assessment`,
    message: `/user/message`,
    userMessage: `/user/message/id`,
    myJobs: `/user/jobs`,
    jobDetails: `/user/job/info`,
    moreProvider: `/provider/job/more-provider`,
    careNetwork: `/user/care-network`,
    careNetworkDetails: `/user/care-network/info`,
    jobRequest: `/user/care-network/job-request`,
    appliedJob: `/user/care-network/applied-job`,
    postedJob: `/user/care-network/posted-job`,
    addPost: `/user/care-network/job-post`,
    payment: `/user/care-network/job-post/payment`,
    paymentSuccess: `/user/care-network/job-post/payment-success`,
    paymentError: `/user/care-network/job-post/payment-error`,
    profile: `/user/profile`,
    calendar: `/user/calendar`,
    subscriptionPlan: `/user/subscription-plan`,
    newsletter: `/user/newsletter`,
    aboutUs: `/user/about-us`,
    privacyPolicy: `/user/privacy-policy`,
    termsCondition: `/user/terms-condition`,
    contactUs: `/user/contact-us`,
    transactionList: `/user/transaction-history`,

    expenseDashboard: `/user/expenses/dashboard`,
    expenseCreate: `/user/expenses/create`,
    expenseEdit: `/user/expenses/edit`,
    expenseList: `/user/expenses/listing`,
    budgetList: `/user/expenses/budget/listing`,

    communityDashboard: `/user/community/dashboard`,
    communitySuggested: `/user/suggested/community`,
    communityFollowing: `/user/community/following`,
    communityList: `/user/community/list`,
    communityInfo: `/user/community/info`,
    communityPostInfo: `/user/community/post/info`,
    communityShareProfile: `/user/community/share/profile`,
    
    careLoyalty: `/user/care-loyalty`,

}